import React, { Fragment, useState } from 'react';
import { INFO_STATUS_BAR_TRANSLATE } from '../../config';
import moment from 'moment';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const StatusBarTextWrap = styled('div')`
  position: relative;
  .status-bar-tip {
    position: absolute;
    z-index: 100;
    background: white;
    padding: 5px 10px;
    border-radius: 3px;
    width: 150px;
    border: 1px solid #ebebeb;
    top: 20px;
    left: 0px;
  }
`;

const INFO_STATUS_BAR_COLORS = {
  ORDER_INFO_DRAFT: '00000',
  ORDER_INFO_NEW: '10000',
  ORDER_INFO_NEED_CONFIRM: '10000',
  ORDER_INFO_INSUFFICIENT_RESERVE: '21000',
  ORDER_INFO_REQUIRE_PAYMENT: '21000',
  ORDER_INFO_READY_TO_PACK: '22100',
  ORDER_INFO_CONFIRM_HOLD: '22000',
  ORDER_INFO_PACKED: '22200',
  ORDER_INFO_PACKED_DOCUMENTS_REQUIRED: '22200',
  ORDER_INFO_PACKED_DOCUMENTS_UPLOADED: '22200',
  ORDER_INFO_IN_PACKING: '22100',
  ORDER_INFO_SHIPPED: '22210',
  ORDER_INFO_COURIER: '22210',
  ORDER_INFO_DELIVERED: '33333',
  ORDER_INFO_PARTIALLY_DELIVERED_NOT_RETURNED: '33332',
  ORDER_INFO_PARTIALLY_DELIVERED_RETURNED: '33333',
  ORDER_INFO_RETURNED: 'ccccc',
  ORDER_INFO_LOST: 'ccce0',
  ORDER_INFO_RETURNING: '00000',
  ORDER_INFO_AT_TAKEOUT_POINT: '22220',
  ORDER_INFO_DONE: '33333',
  ORDER_INFO_RETURNED_TO_CLIENT: '33333',
  ORDER_INFO_CANCELED: 'ccccc',
  ORDER_INFO_WAIT_UNPACK: '22100',
  ORDER_INFO_SORT_CENTER_ARRIVED: '22210',
  ORDER_INFO_SORT_CENTER_SHIPPED: '22210',
  ORDER_INFO_PACKING_ERROR: `22200`,
  ORDER_INFO_PACKING_ERROR_UPDATED: `22200`,
};

const StatusBar = (props) => {
  const { t } = useAutoTranslation();

  const colors_set = {
    0: { stroke: '#ebebeb', fill: '#FFFFFF' }, // phase not started
    1: { stroke: '#7e57c2', fill: '#FFFFFF' }, // phase started
    2: { stroke: '#7e57c2', fill: '#7e57c2' }, // phase finished
    3: { stroke: '#c6eee6', fill: '#c6eee6' }, // success
    e: { stroke: '#f1556c', fill: '#f1556c' }, // phase error
    c: { stroke: '#ebebeb', fill: '#ebebeb' }, // phase cancelled
  };

  var status_colors;

  if (INFO_STATUS_BAR_COLORS.hasOwnProperty(props.status)) {
    status_colors = INFO_STATUS_BAR_COLORS[props.status];
  } else {
    status_colors = 'eeeee';
  }

  var status_title;

  if (INFO_STATUS_BAR_TRANSLATE.hasOwnProperty(props.status)) {
    status_title = t(INFO_STATUS_BAR_TRANSLATE[props.status]);
  } else {
    status_title = 'Unknown status';
  }
  const [tip, changeTip] = useState(false);

  return (
    <div
      className="d-flex flex-column"
      onMouseOver={() => changeTip(true)}
      onMouseOut={() => changeTip(false)}
    >
      <div className="status-bar" data-testid="status-bar">
        <svg
          viewBox="0 0 186 12"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="180px"
          height="12px"
        >
          {props.status === 'ORDER_INFO_CANCELED' ? (
            <rect
              x="0"
              y="5"
              width="180"
              height="3"
              fill="#f1556c"
              data-testid="rect-canceled"
            ></rect>
          ) : (
            <Fragment data-testid="full-status">
              <circle
                cx="5"
                cy="6"
                r="3"
                stroke={colors_set[status_colors[0]].stroke}
                strokeWidth="3"
                fill={colors_set[status_colors[0]].fill}
                data-testid="circle-1"
              />
              <rect
                x="9"
                y="5"
                width="35"
                height="3"
                fill={colors_set[status_colors[1]].stroke}
                data-testid="rect-1"
              />
              <circle
                cx="48"
                cy="6"
                r="3"
                stroke={colors_set[status_colors[1]].stroke}
                strokeWidth="3"
                fill={colors_set[status_colors[1]].fill}
                data-testid="circle-2"
              />
              <rect
                x="52"
                y="5"
                width="35"
                height="3"
                fill={colors_set[status_colors[2]].stroke}
                data-testid="rect-2"
              />
              <circle
                cx="91"
                cy="6"
                r="3"
                stroke={colors_set[status_colors[2]].stroke}
                strokeWidth="3"
                fill={colors_set[status_colors[2]].fill}
                data-testid="circle-3"
              />
              <rect
                x="95"
                y="5"
                width="35"
                height="3"
                fill={colors_set[status_colors[3]].stroke}
                data-testid="rect-3"
              />
              <circle
                cx="134"
                cy="6"
                r="3"
                stroke={colors_set[status_colors[3]].stroke}
                strokeWidth="3"
                fill={colors_set[status_colors[3]].fill}
                data-testid="circle-4"
              />
              <rect
                x="138"
                y="5"
                width="35"
                height="3"
                fill={colors_set[status_colors[4]].stroke}
                data-testid="rect-4"
              />
              <circle
                cx="177"
                cy="6"
                r="3"
                stroke={colors_set[status_colors[4]].stroke}
                strokeWidth="3"
                fill={colors_set[status_colors[4]].fill}
                data-testid="circle-5"
              />
            </Fragment>
          )}
        </svg>
      </div>
      <StatusBarTextWrap>
        <small className="text-muted">{status_title}</small>
        {tip && props.phoneCall && (
          <div className="status-bar-tip">
            Время звонка: <br />{' '}
            <strong>{moment(props.phoneCall).format('DD-MM-YYYY HH:mm:ss')}</strong>
          </div>
        )}
      </StatusBarTextWrap>
    </div>
  );
};

export default StatusBar;
